import { Controller } from "stimulus"
import $ from 'jquery'
import Select2 from 'select2'

export default class extends Controller {
  connect() {
    $(this.element).select2({
      minimumInputLength: 3,
      cache: true,
      ajax: {
        url: '/communities.json',
        dataType: 'json',
        delay: 250,
        data: function (params) {
          return {
            q: params.term,
            page: params.page
          }
        },
        processResults: function (data, params) {
          params.page = params.page || 1
          return {
            results: data.items,
            pagination: {
              more: (params.page * 20) < data.total_count
            }
          }
        }
      }
    })
  }
}
